import React from "react";
import { TinyApiClient } from "./client";

const TinyApiContext = React.createContext<TinyApiClient | undefined>(
  undefined
);

export function TinyApiProvider({
  client,
  children,
}: {
  client: TinyApiClient;
  children: React.ReactNode;
}) {
  return (
    <TinyApiContext.Provider value={client}>{children}</TinyApiContext.Provider>
  );
}

export function useApi(): TinyApiClient {
  const client = React.useContext(TinyApiContext);
  if (!client) {
    throw new Error(
      "useApi must be used inside <TinyApiProvider> — the host app must mount it with a configured TinyApiClient."
    );
  }
  return client;
}
